"use client";

import { Show, SignInButton, UserButton } from "@clerk/nextjs";

import Link from "next/link";
import { Logo } from "@/components/Logo";
import { MainMenu } from "@/components/MainMenu";
import { ModeToggle } from "@/components/ModeToggle";
import { Button } from "@/components/ui/button";

type BlogHeaderProps = {
  searchComponent: React.ReactNode;
};

export function BlogHeader({ searchComponent }: BlogHeaderProps) {
  return (
    <header className="sticky top-0 w-full z-50 bg-background/95 dark:bg-background/80 backdrop-blur-xl border-b border-border shadow-sm">
      <nav className="max-w-screen-xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-8">
          <Logo />
          <div className="hidden md:block">
            <MainMenu />
          </div>
        </div>
        <div className="flex-1 max-w-md hidden lg:block">{searchComponent}</div>
        <div className="flex items-center gap-4">
          <div className="md:hidden">
            <MainMenu />
          </div>
          <Show when="signed-out">
            <SignInButton mode="modal">
              <Button variant="outline" className="shadow-sm">
                Sign In
              </Button>
            </SignInButton>
          </Show>
          <Show when="signed-in">
            <UserButton />
            <Link href="/console">
              <Button variant="default" className="shadow-sm">
                Launch App
              </Button>
            </Link>
          </Show>
          <ModeToggle />
        </div>
      </nav>
    </header>
  );
}
